import IconButton from './IconButton'
import { type IconButtonProps, type IconButtonType } from './types'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { AllowedButtonTags } from '../Button'

const ClientIconButton = forwardRef(function ClientIconButton<T extends AllowedButtonTags = 'button'>(
  {
    onKeyDown: onKeyDown_,
    onKeyUp: onKeyUp_,
    onKeyDownCapture: onKeyDownCapture_,
    onKeyUpCapture: onKeyUpCapture_,
    onClick: onClick_,
    ...props
  }: IconButtonProps<T>,
  ref: React.Ref<HTMLElement>
) {
  const { disabled } = props
  const onKeyDown = disabled ? preventDefault : onKeyDown_
  const onKeyUp = disabled ? preventDefault : onKeyUp_
  const onKeyUpCapture = disabled ? preventDefault : onKeyUpCapture_
  const onClick = disabled ? preventDefault : onClick_
  return (
    <IconButton
      // working around generics
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(props as any)}
      onClick={onClick}
      onChange={onKeyDown}
      onKeyUp={onKeyUp}
      onKeyUpCapture={onKeyUpCapture}
      ref={ref}
    />
  )
}) as IconButtonType

export default ClientIconButton
